export const convertToLocalJSON = (date: Date | null | undefined) => {
  if (!date) return date
  return new Date(date.getTime()).toJSON()
}
